export const notfound = {
  'seo.title': '404 — Страница не найдена | София & Елена',
  'seo.description': 'Страница, которую вы ищете, не найдена.',
  'seo.keywords': '404, страница не найдена',
  'title': 'Страница не найдена',
  'description': 'Страница, которую вы ищете, не существует или была перемещена.',
  'button': 'На главную',
  'buttonAria': 'Вернуться на главную страницу',
};